import React, {useState} from 'react'
import { Switch } from 'antd';
import { Link } from 'react-router-dom';
import { apiRequest } from '../../../api';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import * as NewsReducer from './NewsReducer';

export const TableRow = ({item, index}) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [delLoading, setDelLoading] = useState(false);

    const getNewsLists = () => {
        apiRequest({
            method: "GET",
            url: "news"
        }).then(resp => {
            dispatch(NewsReducer.actions.newsList(resp.data));
        }).catch(error => {
            console.log("get all news list error", error);
        });
    };

    const handleCheckedClick = () => {
        setLoading(true);
        apiRequest({
            method: 'PUT',
            url: `/news/${item.id}`,
            data: {
                ...item,
                status: `${item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'}`
            }
        }).then(() => {
            setLoading(false);
            getNewsLists();
        }).catch((error) => {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.message,
                width: 400
            }); 
        })
    }

    const handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You are about to delete this item.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setDelLoading(true);
                apiRequest({
                    method: 'DELETE',
                    url: `/news/${item.id}`
                }).then((res) => {
                    setDelLoading(false);
                    getNewsLists();
                    window.location.reload();
                }).catch((error) => {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.message,
                        width: 400
                    });
                });
            }
        });
    }

    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{item.title}</td>
            <th scope="col">{item.feature_new}</th>
            <td>{item.news_date}</td>
            <td>{item.status}</td>
            <td>{item.updated_by }</td>  

            <td>
                <Link to={`/news/edit/${item.sku}`}><i className="icon-pencil"></i></Link>
                {
                    delLoading ? (
                        <span className='indicator-progress'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    ) : (
                        <button type="button" onClick={handleDelete}>
                            <i className="icon-trash"></i>
                        </button>
                    )
                }
            </td>
            {/* <td>
                <Switch checked={item.status === 'ACTIVE' ? true : false} onClick={handleCheckedClick} loading={loading} />
            </td> */}
        </tr>
    )
}
